import apiClient from '../../lib/axios';

/**
 * List active document types for upload/create forms.
 * Returns { data: [ { _id, name, code } ] }.
 */
export const getActiveDocumentTypes = async () => {
  const { data } = await apiClient.get('/api/document-types/active');
  return data;
};

/**
 * List folder types (e.g. for "create folder" form).
 * @param {Object} [params] - Optional: isActive, q
 */
export const getFolderTypes = async (params = {}) => {
  const searchParams = new URLSearchParams();
  if (typeof params.isActive === 'boolean') searchParams.set('isActive', params.isActive);
  if (params.q) searchParams.set('q', params.q);
  const query = searchParams.toString();
  const url = query ? `/api/folder-types?${query}` : '/api/folder-types';
  const { data } = await apiClient.get(url);
  return data;
};

export default getActiveDocumentTypes;
